import React from "react";
import { CheckCircle2, Zap, Gauge } from "lucide-react";
import { CountAlongNudge, CountAlongRace } from "@/components/CountAlongClassTools";

const short = (v) => (v.startsWith("Lesson ") ? `L${v.slice(7)}` : v);
export const countAlongSummary = (s, total) => `${s.countalong?.watched.length || 0}/${total} watched · ${s.countalong?.challenges.length || 0}/${total} challenges`;

const Cell = ({ watched, challenge, testId }) => (
  <td className="px-2 py-3 text-center" data-testid={testId} data-watched={watched} data-challenge={challenge}>
    <span className="inline-flex items-center gap-1">
      <CheckCircle2 size={15} className={watched ? "text-emerald-600 dark:text-emerald-400" : "text-muted-foreground/40"} aria-label={watched ? "Watched" : "Not watched"} />
      <Zap size={14} className={challenge ? "text-primary" : "text-muted-foreground/40"} aria-label={challenge ? "Challenge done" : "Challenge not done"} />
    </span>
  </td>
);

// Teacher view: which count-along videos and challenges each pupil has finished.
export const ClassCountAlongs = ({ classId, students, videos, onChanged }) => (
  <div className="border-t border-border" data-testid={`countalongs-${classId}`}>
    <p className="flex flex-wrap items-center gap-4 px-5 pt-3 text-xs text-muted-foreground">
      <span className="inline-flex items-center gap-1"><CheckCircle2 size={13} className="text-emerald-600 dark:text-emerald-400" /> Watched to the end</span>
      <span className="inline-flex items-center gap-1"><Zap size={13} className="text-primary" /> Challenge done (110 beats a minute)</span>
    </p>
    {students.length === 0 ? (
      <p className="px-5 py-4 text-sm text-muted-foreground" data-testid={`countalongs-empty-${classId}`}>No students yet.</p>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-border text-[11px] uppercase tracking-widest text-muted-foreground">
              <th className="px-5 py-3 font-mono font-normal">Student</th>
              {videos.map((v) => <th key={v} className="px-2 py-3 text-center font-mono font-normal" title={v}>{short(v)}</th>)}
              <th className="px-5 py-3 font-mono font-normal">Speed Counter</th>
            </tr>
          </thead>
          <tbody>
            {students.map((s) => {
              const ca = s.countalong || { watched: [], challenges: [] };
              const won = ca.challenges.length === videos.length;
              return (
                <tr key={s.id} className="border-b border-border last:border-0" data-testid={`countalong-student-${s.id}`}>
                  <td className="px-5 py-3 font-medium text-foreground">{s.name || s.email}</td>
                  {videos.map((v, i) => <Cell key={v} watched={ca.watched.includes(v)} challenge={ca.challenges.includes(v)} testId={`countalong-cell-${s.id}-${i}`} />)}
                  <td className="px-5 py-3" data-testid={`speed-counter-${s.id}`} data-won={won}>
                    {won ? <span className="inline-flex items-center gap-1 rounded-full bg-primary px-2 py-0.5 text-xs font-semibold text-primary-foreground"><Gauge size={12} /> Won</span>
                      : <span className="font-mono text-xs text-muted-foreground">{ca.challenges.length}/{videos.length}</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )}
    {students.length > 0 && videos.length > 0 && (
      <div className="grid gap-3 px-5 pb-5 pt-2 md:grid-cols-2">
        <CountAlongNudge classId={classId} students={students} videos={videos} onSent={onChanged} />
        <CountAlongRace classId={classId} />
      </div>
    )}
  </div>
);
